/*
 * Phedros — Dati di nascita
 * Raccoglie i dati anagrafici sulla scheda prodotto e li allega all'ordine
 * come line item properties (name="properties[_...]").
 *
 * I campi visibili sono di supporto; i valori definitivi vengono composti
 * qui dentro negli input nascosti, che vengono agganciati al modulo del
 * carrello tramite l'attributo HTML "form".
 */
(function () {
  'use strict';

  /* ============ Elenco chiuso dei tipi di rapporto ============
     Ogni gruppo porta il REGISTRO interno (la sotto-skill con cui
     il documento va scritto). Fonte: 1B_registro_tipi_di_rapporto.md */
  var RAPPORTI = [
    { gruppo: 'Coppia', registro: 'coppia', voci: [
      'Marito / Moglie', 'Compagno / Compagna', 'Fidanzato / Fidanzata', 'Amante'
    ]},
    { gruppo: 'Attrazione', registro: 'attrazione', voci: [
      'Una persona che mi attrae', 'Frequentazione (non dichiarata)'
    ]},
    { gruppo: 'Ex', registro: 'ex', voci: [
      'Ex marito / Ex moglie', 'Ex compagno / Ex compagna',
      'Ex fidanzato / Ex fidanzata', 'Ex amante'
    ]},
    { gruppo: 'Famiglia', registro: 'non-di-coppia', voci: [
      'Padre', 'Madre', 'Figlio / Figlia', 'Fratello / Sorella',
      'Nonno / Nonna', 'Zio / Zia', 'Cugino / Cugina',
      'Nipote (di nonni)', 'Nipote (di zii)'
    ]},
    { gruppo: 'Famiglia acquisita', registro: 'non-di-coppia', voci: [
      'Suocero / Suocera', 'Genero / Nuora', 'Cognato / Cognata',
      'Patrigno / Matrigna', 'Figliastro / Figliastra', 'Fratellastro / Sorellastra'
    ]},
    { gruppo: 'Lavoro', registro: 'non-di-coppia', voci: [
      'Capo', 'Dipendente / Collaboratore', 'Collega', 'Socio / Socia'
    ]},
    { gruppo: 'Amicizia', registro: 'non-di-coppia', voci: [
      'Amico / Amica', 'Ex amico / Amicizia interrotta'
    ]}
  ];

  /* ============ Geocoding città ============ */
  var GEO_URL = 'https://geocoding-api.open-meteo.com/v1/search';
  var FALLBACK = [
    { name: 'Roma', admin1: 'Lazio', country: 'Italia', latitude: 41.9028, longitude: 12.4964, timezone: 'Europe/Rome' },
    { name: 'Milano', admin1: 'Lombardia', country: 'Italia', latitude: 45.4642, longitude: 9.19, timezone: 'Europe/Rome' },
    { name: 'Napoli', admin1: 'Campania', country: 'Italia', latitude: 40.8518, longitude: 14.2681, timezone: 'Europe/Rome' },
    { name: 'Torino', admin1: 'Piemonte', country: 'Italia', latitude: 45.0703, longitude: 7.6869, timezone: 'Europe/Rome' },
    { name: 'Palermo', admin1: 'Sicilia', country: 'Italia', latitude: 38.1157, longitude: 13.3615, timezone: 'Europe/Rome' },
    { name: 'Bologna', admin1: 'Emilia-Romagna', country: 'Italia', latitude: 44.4949, longitude: 11.3426, timezone: 'Europe/Rome' },
    { name: 'Firenze', admin1: 'Toscana', country: 'Italia', latitude: 43.7696, longitude: 11.2558, timezone: 'Europe/Rome' },
    { name: 'Bari', admin1: 'Puglia', country: 'Italia', latitude: 41.1171, longitude: 16.8719, timezone: 'Europe/Rome' },
    { name: 'Cagliari', admin1: 'Sardegna', country: 'Italia', latitude: 39.2238, longitude: 9.1217, timezone: 'Europe/Rome' },
    { name: 'Catania', admin1: 'Sicilia', country: 'Italia', latitude: 37.5079, longitude: 15.083, timezone: 'Europe/Rome' }
  ];

  function labelOf(c) {
    var p = [c.name];
    if (c.admin1 && c.admin1 !== c.name) p.push(c.admin1);
    if (c.country) p.push(c.country);
    return p.join(', ');
  }
  function capWords(s) {
    return s.replace(/(^|[\s'\-’])([a-zà-ÿ])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }
  function geoFetch(q) {
    return fetch(GEO_URL + '?name=' + encodeURIComponent(q) + '&count=6&language=it&format=json')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        return (j && j.results ? j.results : []).map(function (r) {
          return { name: r.name, admin1: r.admin1, country: r.country,
                   latitude: r.latitude, longitude: r.longitude, timezone: r.timezone };
        });
      });
  }
  function fallbackSearch(q) {
    q = q.toLowerCase();
    return FALLBACK.filter(function (c) { return c.name.toLowerCase().indexOf(q) === 0; }).slice(0, 6);
  }

  /* ============ Utilità ============ */
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function dataValida(gg, mm, aaaa) {
    if (!gg || !mm || !aaaa) return false;
    if (gg < 1 || gg > 31) return false;
    if (aaaa < 1900 || aaaa > 2030) return false;
    var d = new Date(Date.UTC(aaaa, mm - 1, gg));
    return d.getUTCDate() === gg && d.getUTCMonth() === mm - 1;
  }

  function normalizzaOra(v) {
    if (!v) return '';
    var t = String(v).trim().replace(/[.,;hH ]/g, ':').replace(/[^0-9:]/g, '');
    if (/^\d{3,4}$/.test(t)) t = t.slice(0, t.length - 2) + ':' + t.slice(-2);
    var parts = t.split(':');
    var h = parseInt(parts[0], 10);
    var m = parts.length > 1 ? parseInt(parts[1], 10) : 0;
    if (isNaN(h) || h > 23 || isNaN(m) || m > 59) return null; // null = non valida
    return pad2(h) + ':' + pad2(m);
  }

  /* ============ Inizializzazione di un blocco ============ */
  function init(root) {
    if (!root || root.__phdnReady) return;
    root.__phdnReady = true;

    var persone = parseInt(root.getAttribute('data-persone'), 10) === 1 ? 1 : 2;
    var chiediOra = root.getAttribute('data-chiedi-ora') === 'true';
    var chiediRapporto = root.getAttribute('data-chiedi-rapporto') === 'true';

    var selRapporto = root.querySelector('[data-phdn-rapporto]');
    var errBox = root.querySelector('[data-phdn-error]');
    var out = root.querySelector('[data-phdn-out]');

    /* --- Popola il menu dei rapporti --- */
    if (selRapporto) {
      RAPPORTI.forEach(function (g) {
        var og = document.createElement('optgroup');
        og.label = g.gruppo;
        g.voci.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v;
          o.textContent = v;
          o.setAttribute('data-registro', g.registro);
          og.appendChild(o);
        });
        selRapporto.appendChild(og);
      });
    }

    /* --- Mostra/nascondi secondo le impostazioni --- */
    if (persone === 1) {
      var p2 = root.querySelector('[data-phdn-person="2"]');
      if (p2) p2.hidden = true;
      // il blocco 1 non ha bisogno del titolo "Persona 1" se è solo uno
      var t1 = root.querySelector('[data-phdn-person="1"] .phdn__person-title');
      if (t1) t1.hidden = true;
    }
    if (!chiediRapporto) {
      var rw = root.querySelector('[data-phdn-rapporto-wrap]');
      if (rw) rw.hidden = true;
    }
    if (!chiediOra) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-phdn-ora-wrap]'), function (el) {
        el.hidden = true;
      });
    }

    /* --- Stato per persona --- */
    var persons = [];
    Array.prototype.forEach.call(root.querySelectorAll('[data-phdn-person]'), function (el) {
      var idx = parseInt(el.getAttribute('data-phdn-person'), 10);
      if (idx > persone) return;
      persons.push({
        idx: idx,
        el: el,
        nome: el.querySelector('[data-phdn-nome]'),
        gg: el.querySelector('[data-phdn-gg]'),
        mm: el.querySelector('[data-phdn-mm]'),
        aaaa: el.querySelector('[data-phdn-aaaa]'),
        ora: el.querySelector('[data-phdn-ora]'),
        noora: el.querySelector('[data-phdn-noora]'),
        citta: el.querySelector('[data-phdn-citta]'),
        ac: el.querySelector('[data-phdn-ac]'),
        picked: el.querySelector('[data-phdn-picked]'),
        scelta: null,
        items: [],
        deb: null,
        req: 0
      });
    });

    function setOut(name, value) {
      var f = out.querySelector('input[name="properties[' + name + ']"]');
      if (f) f.value = value == null ? '' : value;
    }

    /* --- Autocomplete città --- */
    function chiudiAc(p) {
      p.ac.hidden = true;
      p.citta.setAttribute('aria-expanded', 'false');
    }
    function renderAc(p, items) {
      p.items = items || [];
      p.ac.innerHTML = '';
      if (!p.items.length) {
        var e = document.createElement('div');
        e.className = 'phdn__ac-empty';
        e.textContent = 'Nessuna città trovata. Controlla l’ortografia.';
        p.ac.appendChild(e);
        p.ac.hidden = false;
        return;
      }
      p.items.forEach(function (c, i) {
        var d = document.createElement('div');
        d.className = 'phdn__ac-item';
        d.setAttribute('role', 'option');
        var sub = [];
        if (c.admin1) sub.push(c.admin1);
        if (c.country) sub.push(c.country);
        var strong = document.createElement('span');
        strong.textContent = c.name;
        var small = document.createElement('small');
        small.textContent = sub.join(', ');
        d.appendChild(strong);
        d.appendChild(small);
        d.addEventListener('mousedown', function (ev) { ev.preventDefault(); scegli(p, i); });
        p.ac.appendChild(d);
      });
      p.ac.hidden = false;
      p.citta.setAttribute('aria-expanded', 'true');
    }
    function scegli(p, i) {
      var c = p.items[i];
      if (!c) return;
      p.scelta = c;
      p.citta.value = labelOf(c);
      p.picked.textContent = '✓ ' + labelOf(c);
      chiudiAc(p);
      aggiorna();
    }
    function cerca(p, q) {
      var id = ++p.req;
      geoFetch(q).then(function (items) {
        if (id !== p.req) return;
        if (items.length) { renderAc(p, items); return; }
        var qc = capWords(q);
        if (qc === q) { renderAc(p, fallbackSearch(q)); return; }
        geoFetch(qc).then(function (i2) {
          if (id !== p.req) return;
          renderAc(p, i2.length ? i2 : fallbackSearch(q));
        })['catch'](function () { if (id === p.req) renderAc(p, fallbackSearch(q)); });
      })['catch'](function () { if (id === p.req) renderAc(p, fallbackSearch(q)); });
    }

    persons.forEach(function (p) {
      p.citta.addEventListener('input', function () {
        p.scelta = null;
        p.picked.textContent = '';
        aggiorna();
        var q = p.citta.value.trim();
        if (q.length < 2) { chiudiAc(p); return; }
        if (p.deb) clearTimeout(p.deb);
        p.deb = setTimeout(function () { cerca(p, q); }, 220);
      });
      p.citta.addEventListener('blur', function () { setTimeout(function () { chiudiAc(p); }, 150); });

      if (p.noora) {
        p.noora.addEventListener('change', function () {
          if (p.noora.checked) { p.ora.value = ''; p.ora.disabled = true; }
          else { p.ora.disabled = false; }
          aggiorna();
        });
      }
      [p.nome, p.gg, p.mm, p.aaaa, p.ora].forEach(function (el) {
        if (el) el.addEventListener('input', aggiorna);
        if (el) el.addEventListener('change', aggiorna);
      });
    });

    if (selRapporto) selRapporto.addEventListener('change', aggiorna);

    /* --- Composizione dei valori in uscita --- */
    function aggiorna() {
      if (selRapporto && chiediRapporto) {
        var opt = selRapporto.options[selRapporto.selectedIndex];
        setOut('_TipoRapporto', selRapporto.value || '');
        setOut('_Registro', (opt && opt.getAttribute('data-registro')) || '');
      } else {
        setOut('_TipoRapporto', '');
        setOut('_Registro', '');
      }

      persons.forEach(function (p) {
        var n = p.idx;
        setOut('_P' + n + 'Nome', p.nome ? p.nome.value.trim() : '');

        var gg = parseInt(p.gg.value, 10);
        var mm = parseInt(p.mm.value, 10);
        var aaaa = parseInt(p.aaaa.value, 10);
        setOut('_P' + n + 'Data', dataValida(gg, mm, aaaa) ? (aaaa + '-' + pad2(mm) + '-' + pad2(gg)) : '');

        var senzaOra = !chiediOra || (p.noora && p.noora.checked);
        var oraNorm = senzaOra ? '' : normalizzaOra(p.ora ? p.ora.value : '');
        setOut('_P' + n + 'Ora', oraNorm && oraNorm !== null ? oraNorm : '');
        setOut('_P' + n + 'OraSconosciuta', senzaOra ? 'si' : 'no');

        var c = p.scelta;
        setOut('_P' + n + 'Citta', c ? c.name : '');
        setOut('_P' + n + 'Provincia', c ? (c.admin1 || '') : '');
        setOut('_P' + n + 'Paese', c ? (c.country || '') : '');
        setOut('_P' + n + 'Lat', c ? c.latitude : '');
        setOut('_P' + n + 'Lon', c ? c.longitude : '');
        setOut('_P' + n + 'Fuso', c ? (c.timezone || '') : '');
      });
    }

    /* --- Validazione --- */
    function validazione() {
      var errori = [];

      if (chiediRapporto && selRapporto && !selRapporto.value) {
        errori.push('Scegli che rapporto c’è tra le due persone.');
      }

      persons.forEach(function (p) {
        var et = persons.length > 1 ? ('Persona ' + p.idx + ': ') : '';
        if (!p.nome.value.trim()) errori.push(et + 'inserisci il nome.');

        var gg = parseInt(p.gg.value, 10);
        var mm = parseInt(p.mm.value, 10);
        var aaaa = parseInt(p.aaaa.value, 10);
        if (!gg || !mm || !aaaa) {
          errori.push(et + 'inserisci giorno, mese e anno di nascita.');
        } else if (!dataValida(gg, mm, aaaa)) {
          errori.push(et + 'questa data di nascita non esiste, controlla giorno, mese e anno.');
        }

        var senzaOra = !chiediOra || (p.noora && p.noora.checked);
        if (!senzaOra) {
          if (!p.ora.value) {
            errori.push(et + 'inserisci l’ora di nascita, oppure spunta «Non conosco l’ora».');
          } else if (normalizzaOra(p.ora.value) === null) {
            errori.push(et + 'ora di nascita non valida: scrivila come HH:MM (es. 14:30).');
          }
          if (!p.scelta) {
            errori.push(et + 'scegli la città di nascita dall’elenco che compare mentre scrivi.');
          }
        }
      });

      return errori;
    }

    function mostraErrori(errori) {
      if (!errori.length) { errBox.hidden = true; errBox.innerHTML = ''; return; }
      var ul = document.createElement('ul');
      errori.forEach(function (e) {
        var li = document.createElement('li');
        li.textContent = e;
        ul.appendChild(li);
      });
      errBox.innerHTML = '';
      errBox.appendChild(ul);
      errBox.hidden = false;
      try { errBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }

    /* --- Aggancio al modulo del carrello --- */

    /* ATTENZIONE: su molti temi (Dawn, Studio e derivati) ci sono DUE form che
       puntano a /cart/add: quello dei pagamenti rateali, che compare per primo
       nel documento, e quello vero dell'aggiunta al carrello. Si distinguono
       perché solo il secondo contiene il pulsante con name="add". */
    function trovaForm() {
      var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
      if (!forms.length) return null;
      var i;
      for (i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('[name="add"]')) return forms[i];
      }
      for (i = 0; i < forms.length; i++) {
        if (forms[i].offsetParent !== null) return forms[i];
      }
      return forms[0];
    }

    /* ATTENZIONE: form.id NON restituisce l'id del form quando il form contiene
       un campo chiamato "id" — e Shopify ce lo mette sempre (<input name="id">
       con la variante). L'accesso per nome dei form HTML mette in ombra la
       proprietà, e form.id restituisce quell'input. Va usato getAttribute. */
    function idDelForm(form) {
      var id = form.getAttribute('id');
      if (!id) {
        id = 'phdn-cart-form-' + Math.random().toString(36).slice(2, 8);
        form.setAttribute('id', id);
      }
      return id;
    }

    function agganciaForm() {
      var form = trovaForm();
      if (!form) return false;
      var formId = idDelForm(form);

      Array.prototype.forEach.call(out.querySelectorAll('[data-phdn-out-field]'), function (f) {
        f.setAttribute('form', formId);
      });

      /* Verifica che l'aggancio sia davvero avvenuto: se il browser non associa
         gli input al form, i dati non arriverebbero all'ordine in silenzio. */
      var campione = out.querySelector('[data-phdn-out-field]');
      if (campione && campione.form !== form) {
        console.warn('[phedros-dati-nascita] input non agganciati al form del carrello: i dati non verrebbero inviati.');
        return false;
      }

      if (form.__phdnBound) return true;
      form.__phdnBound = true;

      form.addEventListener('submit', function (ev) {
        aggiorna();
        var errori = validazione();
        if (errori.length) {
          ev.preventDefault();
          ev.stopPropagation();
          if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
          mostraErrori(errori);
          return false;
        }
        mostraErrori([]);
      }, true); // capture: interveniamo prima del tema

      // Molti temi aggiungono al carrello via click AJAX sul bottone
      var bottoni = form.querySelectorAll('[type="submit"], [name="add"]');
      Array.prototype.forEach.call(bottoni, function (b) {
        b.addEventListener('click', function (ev) {
          aggiorna();
          var errori = validazione();
          if (errori.length) {
            ev.preventDefault();
            ev.stopPropagation();
            if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
            mostraErrori(errori);
            return false;
          }
          mostraErrori([]);
        }, true);
      });

      return true;
    }

    aggiorna();
    if (!agganciaForm()) {
      // il form può comparire dopo (temi che ricaricano la sezione)
      var tentativi = 0;
      var t = setInterval(function () {
        if (agganciaForm() || ++tentativi > 20) clearInterval(t);
      }, 400);
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-phdn]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: la sezione viene ricaricata
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();